import { Capacitor, registerPlugin } from '@capacitor/core';

const NativeCamera = registerPlugin('NativeCamera');

const extensionForMimeType = (mimeType) => {
  if (mimeType === 'image/png') return 'png';
  if (mimeType === 'image/webp') return 'webp';
  return 'jpg';
};

export const NativeCameraService = {
  isAvailable() {
    try {
      return Capacitor.getPlatform?.() === 'android';
    } catch (_) {
      return false;
    }
  },

  async openPhotoCapture() {
    const result = await NativeCamera.open();
    if (!result || result.cancelled) {
      return null;
    }

    const fileUrl = Capacitor.convertFileSrc(result.uri || result.path);
    const response = await fetch(fileUrl);
    const blob = await response.blob();
    const mimeType = result.mimeType || blob.type || 'image/jpeg';
    const extension = extensionForMimeType(mimeType);
    const source = result.source === 'gallery' ? 'gallery' : 'camera';

    return new File([blob], `native-${source}-${Date.now()}.${extension}`, {
      type: mimeType,
      lastModified: Date.now()
    });
  }
};
